import React, { useEffect, useState } from 'react';
import api from '../services/apiService';

export const loStatusLabel = (status) => {
  if (!status) return 'Noch kein Abgleich';
  if (status.paused) return 'Übertragung pausiert';
  if (status.dirty) return 'Änderung vorgemerkt';
  return ({ not_selected:'Nicht ausgewählt', queued:'Wartet auf Übertragung', sending:'Wird übertragen', retry:'Wiederholung vorgesehen', failed:'Fehler – Angaben prüfen', synced:'Übertragen' })[status.status] || status.status;
};
export const loPublicationLabel = status => ({ published:'Veröffentlicht', withdrawn:'Zurückgezogen', moderation_blocked:'Durch Moderation gesperrt', provider_not_approved:'Anbieter noch nicht freigegeben', category_inactive:'Kategorie deaktiviert', needs_revision:'Neue Übertragung erforderlich' })[status] || status || 'Noch keine Bestätigung';

export default function LoSyncStatus({ itemId, refresh = 0 }) {
  const [status, setStatus] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try { const res = await api.get(`/lo-integration/status/${itemId}`); if (active) { setStatus(res.data); setError(''); } }
      catch (e) { if (active) setError(e.response?.data?.error || 'Synchronisationsstatus nicht erreichbar.'); }
    };
    load(); const interval = setInterval(load, 5000);
    return () => { active = false; clearInterval(interval); };
  }, [itemId, refresh]);
  const retry = async () => {
    setBusy(true);
    try { const res = await api.post(`/lo-integration/retry/${itemId}`); setStatus(res.data); setError(''); }
    catch (e) { setError(e.response?.data?.error || 'Erneuter Abgleich konnte nicht gestartet werden.'); }
    finally { setBusy(false); }
  };
  return <section aria-label="Liftoutlet-Synchronisation" style={{ margin:'1rem 0', padding:'1rem', border:'1px solid #ccc', borderRadius:6 }}>
    <h3>Liftoutlet-Synchronisation</h3>
    {error && <p role="alert">{error}</p>}
    {status && <>
      <p><strong>{loStatusLabel(status)}</strong> · Revision {status.revision || 0} · Versuche {status.attempts || 0}</p>
      <p>Zuletzt von Liftoutlet bestätigt: {loPublicationLabel(status.response?.publicationStatus)}{status.response?.mediaStatus === 'ready' ? ' · Bilder verarbeitet' : ''}</p>
      {status.error && <p role={status.dirty || ['queued','sending','retry'].includes(status.status) ? 'status' : 'alert'}>
        {(status.dirty || ['queued','sending','retry'].includes(status.status)) && 'Fehler des vorherigen Versuchs: '}{status.error}
      </p>}
      {status.connectionError && <p role="alert">{status.connectionError}</p>}
      {status.response?.externalListingId && <p>Inserat-ID: {status.response.externalListingId}</p>}
      {status.response?.externalUrl && <a href={status.response.externalUrl} target="_blank" rel="noreferrer">Inserat aufrufen</a>}
      <p>Letzte Bestätigung: {status.checked_at ? new Date(status.checked_at).toLocaleString('de-DE') : 'noch keine'}</p>
      <button type="button" disabled={busy} onClick={retry}>{busy ? 'Wird vorgemerkt …' : 'Erneut abgleichen'}</button>
    </>}
  </section>;
}
